import { Component, ElementRef, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Article } from 'app/library/article/models/article.model';
import { GeneralAnalyticsService } from 'app/services/general-analytics.service';
import { RelatedPostDetailsComponent } from '../dialogs/related-post-details/related-post-details.component';
import { SwiperOptions } from 'swiper/types/swiper-options';
import { Navigation } from 'swiper/modules';

@Component({
    selector: 'app-related-postings-swipper',
    templateUrl: './related-postings-swipper.component.html',
    styleUrls: ['./related-postings-swipper.component.scss'],
})
export class RelatedPostingsSwipperComponent implements OnInit {
    @ViewChildren('postingsRef') postingsRef!: QueryList<ElementRef>;
    isPostingVisible: boolean = false;

    public swiperConfig: SwiperOptions = {
        modules: [Navigation],
        a11y: { enabled: true },
        direction: 'horizontal',
        slidesPerView: 'auto',
        keyboard: false,
        mousewheel: false,
        scrollbar: false,
        pagination: false,
        spaceBetween: 30,
        loop: false,
        navigation: {
            nextEl: '.related-postings-swiper-button-next',
            prevEl: '.related-postings-swiper-button-prev',
        },
        updateOnWindowResize: true,
    };

    @Input()
    article: Article;
    arrayOfViewedElements: string[] = [];

    constructor(private _router: Router, private _matDialog: MatDialog, private _locationBasedAnalyticsService: GeneralAnalyticsService) {}

    ngOnInit(): void {}

    ngAfterViewInit(): void {
        window.addEventListener('scroll', this.isElementInViewPort, true);
        this.isElementInViewPort(null);
    }

    openPostInDialog(index: number, isFirst: boolean, isLast: boolean) {
        const dialogRef = this._matDialog.open(RelatedPostDetailsComponent, {
            width: '656px',
        });

        dialogRef.componentInstance.relatedPostings = this.article.relatedPostings;
        dialogRef.componentInstance.index = index;
        dialogRef.componentInstance.isFirst = isFirst;
        dialogRef.componentInstance.isLast = isLast;
    }

    isElementInViewPort = async (event: any): Promise<void> => {
        //checks if isScrolledIntoView
        if (this.postingsRef.length && this._router.url === '/grow') {
            for (let i = 0; i < this.postingsRef.toArray().length; i++) {
                const postingsRefArray = this.postingsRef.toArray();
                const postingElement = postingsRefArray[i];

                let currentPostId = postingElement.nativeElement.getAttribute('postId');
                let addedToArray = this.arrayOfViewedElements.some((postId) => postId === currentPostId);

                const rect = postingElement.nativeElement.getBoundingClientRect();
                const leftShown = rect.left >= 0;
                const rightShown = rect.right <= (window.innerWidth || document.documentElement.clientWidth);
                const topShown = rect.top >= 0;
                const bottomShown = rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);
                this.isPostingVisible = topShown && bottomShown && leftShown && rightShown;

                if (!addedToArray && this.isPostingVisible) {
                    this.arrayOfViewedElements.push(currentPostId);

                    /* if (this.arrayOfViewedElements.includes(currentPostId)) {
                        const postingResource = this.featuredWidget.content.find(postings => postings.posting.id === currentPostId);
                        this._locationBasedAnalyticsService.createPostingEvent('posting_viewed', postingResource.posting.id, postingResource.posting.postingType.id, postingResource.posting.translation.title, postingResource.audience, this.featuredWidget.id, this.featuredWidget.name);
                    } */
                }
            }
        }
    };

    onSlideChangeTransitionEnd() {
        this.isElementInViewPort(null);
    }

    ngOnDestroy() {
        window.removeEventListener('scroll', this.isElementInViewPort, true);
    }
}
